import PropTypes from 'prop-types';
import SlidingBetslipViewImpl from './sliding-betslip-view.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * SlidingBetslipView view displaying betslip and betslip button inside slider.
 *
 * @class SlidingBetslipView
 * @name view
 *
 * @memberof Mojito.Modules.SlidingBetslip
 */

/**
 * SlidingBetslipView prop types.
 *
 * @memberof Mojito.Modules.SlidingBetslip.view
 *
 * @property {boolean} isOpen - True if sliding betslip should be opened, false otherwise.
 * @property {boolean} [isBetslipButtonMinimized = false] - True if betslip button should be minimized, false otherwise.
 * @property {boolean} [isBetslipButtonCommitted = false] - True if betslip button should be displayed as committed, false otherwise.
 * @property {boolean} [isBetslipButtonDisabled = false] - True if betslip button should be disabled, false otherwise.
 * @property {Function} [onBetslipButtonClick = () => {}] - Callback triggered once betslip button has been clicked.
 * @property {Function} [onCloseClick = () => {}] - Callback for closing on the close button.
 * @property {Function} [onClickOutside = () => {}] - Callback on clicking outside sliding betslip component.
 * @property {Function} [onClosed = ()=>{}] - Callback to invoke when sliding betslip has been closed.
 * @property {Function} [onOpened = ()=>{}] - Callback to invoke when sliding betslip has been opened.
 * @property {node} [children] - The content that should be displayed in the SlidingPane.
 * @property {boolean} [enableFreebetsIndication] - True if free bets indication should be shown on betslip button.
 * @property {boolean} [isQuickBetslip = false] - Indication if quick betslip is showing.
 * @property {Function} [onSwipeUp = ()=>{}] - Callback to invoke when user swipes up bottom sheet.
 * @property {Function} [onSwipeDown = ()=>{}] - Callback to invoke when user swipes up bottom sheet.
 */

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isBetslipButtonMinimized: PropTypes.bool,
    isBetslipButtonCommitted: PropTypes.bool,
    isBetslipButtonDisabled: PropTypes.bool,
    onCloseClick: PropTypes.func,
    onClickOutside: PropTypes.func,
    onBetslipButtonClick: PropTypes.func,
    onClosed: PropTypes.func,
    onOpened: PropTypes.func,
    children: PropTypes.node,
    enableFreebetsIndication: PropTypes.bool,
    isQuickBetslip: PropTypes.bool,
    onSwipeUp: PropTypes.func,
    onSwipeDown: PropTypes.func,
};

const defaultProps = {
    onBetslipButtonClick: noop,
    onCloseClick: noop,
    onClickOutside: noop,
    onClosed: noop,
    onOpened: noop,
    isBetslipButtonMinimized: false,
    isBetslipButtonCommitted: false,
    isBetslipButtonDisabled: false,
    isQuickBetslip: false,
    onSwipeUp: noop,
    onSwipeDown: noop,
};

export default UIView('SlidingBetslipView', SlidingBetslipViewImpl, propTypes, defaultProps);
